export default {
  name: 'reportesV2',
  component: () =>
    import(
      /* webpackChunkName: "reportesV2Layout" */ "@/modules/reportesV2/layouts/reportesV2Layout.vue"
    ),
  redirect: "/reportesV2/dashboard",
  children: [
    {
      path: "dashboard",
      name: "reportesV2-dashboard",
      component: () =>
        import(
          /* webpackChunkName: "dashboard-v2" */ "@/modules/reportesV2/pages/Dashboard.vue"
        ),
    },
    {
      path: "llamadas",
      name: "reportesV2-llamadas",
      component: () =>
        import(
          /* webpackChunkName: "llamadas-v2" */ "@/modules/reportesV2/pages/Llamadas.vue"
        ),
    },
    {
      // Reutiliza tal cual la página ya rediseñada de Admin > Herramientas >
      // Grabaciones (no depende de nada propio de ese layout: solo Vuex global
      // y apiClient). Esa ruta original sigue intacta; esto es una entrada nueva.
      path: "grabaciones",
      name: "reportesV2-grabaciones",
      component: () =>
        import(
          /* webpackChunkName: "herramientas-grabaciones" */ "@/modules/admin/pages/herramientas/Grabaciones.vue"
        ),
    },
    {
      path: "overflow",
      name: "reportesV2-overflow",
      component: () =>
        import(
          /* webpackChunkName: "overflow-v2" */ "@/modules/reportesV2/pages/Overflow.vue"
        ),
    },
    {
      path: "extensiones",
      name: "reportesV2-extensiones",
      component: () =>
        import(
          /* webpackChunkName: "extensiones-v2" */ "@/modules/reportesV2/pages/Extensiones.vue"
        ),
    },
    {
      path: "ivrs",
      name: "reportesV2-ivrs",
      component: () =>
        import(
          /* webpackChunkName: "ivrs-v2" */ "@/modules/reportesV2/pages/Ivrs.vue"
        ),
    },
    {
      path: "colas",
      name: "reportesV2-colas",
      component: () =>
        import(
          /* webpackChunkName: "colas-v2" */ "@/modules/reportesV2/pages/Colas.vue"
        ),
    },
    {
      path: "curso",
      name: "reportesV2-curso",
      component: () =>
        import(
          /* webpackChunkName: "curso-v2" */ "@/modules/reportesV2/pages/EnCurso.vue"
        ),
    },
  ],
}
